// i18n area 'backups' — locale fr-FR (task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.fr-FR.meta.json.
import type { enUS } from './backups'

export const frFR: typeof enUS = {
  ckpt: {
    contents: 'Accepte',
    contentsHint:
      'Ce qui peut atterrir ici. « Checkpoints » est la configuration du cluster, « Sauvegardes de données » sont celles des VM : les deux lectures se composent, une destination peut accepter les deux.',
    content: { checkpoints: 'Checkpoints', backups: 'Sauvegardes de données' },
    destinationsTitle: 'Destinations de backup',
    checkpointsTitle: 'Checkpoints',
    restoreTitle: 'Restauration',
    addDestination: 'Ajouter une destination',
    addDestinationTitle: 'Ajouter une destination de backup',
    editDestinationTitle: 'Modifier la destination',
    storage: 'Storage',
    storageHint:
      'Un storage dir-like (dir/NFS/CIFS/CephFS) — les artefacts sont des fichiers ordinaires sous le namespace de la plateforme.',
    schedule: 'Planification',
    scheduleNone: 'Manuel uniquement',
    scheduleHourly: 'Toutes les heures',
    scheduleDaily: 'Quotidienne',
    scheduleWeekly: 'Hebdomadaire',
    scheduleHour: 'Heure',
    scheduleWeekday: 'Jour',
    scheduleHint:
      "Les checkpoints planifiés n'ont pas d'opérateur pour saisir la masterpass : les secrets du keystore sont empaquetés comme placeholders.",
    retention: 'Retention',
    retentionHint:
      'Combien de checkpoints planifiés garder — le sweeper retire les plus anciens au-delà du compte. Les checkpoints manuels et pré-restauration ne sont jamais retirés.',
    paused: 'En pause',
    pausedHint:
      "Le blackout de l'opérateur : tant que la pause dure, rien n'est planifié ni élagué sur cette destination — policies de données comme checkpoints. Les exécutions en cours ne sont jamais touchées.",
    rescan: 'Réadopter les artefacts',
    orphanRuns: '{n} exécutions orphelines',
    orphanRunsHint:
      'Exécutions planifiées de policies qui n’existent plus sur cette destination : aucune rétention ne les gouverne — jamais comptées ni élaguées — et seule une main les supprime. La lentille « backups » de tvirt diagnose nomme les policies supprimées.',
    rescanTitle: 'Réadoption des artefacts de {name}',
    rescanHint:
      'Reconstruit le catalogue des sauvegardes (VM/CT/App) à partir des manifestes des artefacts présents sur la destination. Les lignes existantes ne sont jamais touchées ; les sauvegardes de politiques inconnues restent orphelines (jamais élaguées automatiquement). Le geste après une restauration bootstrap.',
    masterpassDrWarning:
      'Scénario de sinistre : les disques LUKS ne reviennent QUE depuis un checkpoint AVEC masterpass. Les checkpoints planifiés emballent des espaces réservés — prenez périodiquement un checkpoint manuel avec masterpass.',
    policy: {
      title: 'Policies de sauvegarde des données',
      hint: "Des policies nommées : quels objets (kind, tags, scopes), à quelle fréquence, quand une exécution peut démarrer, et combien de copies garder. Le geste d'enrôlement reste au propriétaire de l'objet : les tags s'assignent sur son propre scope.",
      add: 'Ajouter une policy',
      column: 'Policies de données',
      name: 'Nom',
      nameHint:
        'Étiquette de la policy, unique dans la destination. Les exécutions suivent l’id stable de la policy : renommer est gratuit ; la supprimer rend ses exécutions orphelines (plus comptées ni élaguées).',
      kindLocked: 'La famille d’objets d’une policy existante ne se change pas : créez une nouvelle policy.',
      kindLabel: 'Objets',
      kind: { vm: 'Machines virtuelles', ct: 'Containers', app: 'Apps' },
      tags: 'Sélecteur de tags',
      tagsHint:
        'Paires tag=valeur, séparées par des virgules, en AND. Tags et scopes vides ne sélectionnent rien — jamais « tout ».',
      scopes: 'Scopes',
      scopesHint: 'Chemins de scope (sous-arbres), séparés par des virgules, en OR entre eux.',
      windowStart: 'Fenêtre de',
      windowEnd: 'Fenêtre à',
      windowHint:
        "Fenêtre d'exécution (HH:MM, heure locale ; un début au-delà de la fin enjambe minuit). Elle ne gouverne que le DÉMARRAGE : une exécution qui la déborde n'est jamais tuée.",
      mode: 'Mode',
      modeHint: "L'incrémental chevauche la famille de séries ; une série cassée dégrade en full, dit dans le journal.",
      modeFull: 'Full',
      modeIncremental: 'Incrémental',
      requireQuiesce: 'Exiger le quiesce (guest agent)',
      paused: 'Policy en pause',
      retentionNone: 'Tout garder',
      retentionCount: 'Compte',
      retentionGfs: 'Anneaux GFS',
      gfs: {
        keepLast: 'Derniers',
        daily: 'Quotidiens',
        weekly: 'Hebdomadaires',
        monthly: 'Mensuels',
        yearly: 'Annuels'
      },
      gfsHint:
        'Pour chaque anneau, on garde la sauvegarde la plus récente de chacune des N dernières périodes. Une sauvegarde gardée maintient toute sa chaîne en vie — jamais une base avec des orphelins.',
      lastRun: 'Dernière exécution',
      neverRan: 'jamais exécutée'
    },
    lastCheckpoint: 'Dernier checkpoint',
    neverRun: 'Jamais créé',
    createNow: 'Créer un checkpoint',
    createNowTitle: 'Créer un checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      "Protège les valeurs secrètes du keystore (argon2id → AES-256-GCM, par valeur). Elle n'est jamais enregistrée : conservez-la — sans elle, une restauration produit des placeholders à la place des vrais secrets.",
    masterpassEmptyHint: 'Laissez vide pour empaqueter des placeholders explicites à la place des secrets.',
    createStarted: 'Checkpoint en cours…',
    destinationInUseError: "'{name}' contient encore des checkpoints — supprimez-les d'abord.",
    origin: 'Origine',
    originManual: 'manuel',
    originSchedule: 'planifié',
    originPreRestore: 'pré-restauration',
    originPreChange: 'pré-modification',
    preChangeRetention: 'Checkpoints pré-modification',
    preChangeRetentionHint:
      'Vide = désactivé. La première écriture de configuration après une période de calme fige ici l’état précédent (origine pré-modification) ; les plus récents sont conservés jusqu’au compte — rétention propre, élaguable.',
    diffTitle: 'Aperçu des modifications',
    diffFailed: 'Aperçu impossible',
    diffRetry: 'Réessayer',
    diffCounts: '{changed} à modifier · {missing} à créer · {extra} en trop · {equal} identiques',
    diffChanged: 'change',
    diffMissing: 'serait créé',
    diffExtra: 'serait supprimé',
    diffJsonb: 'références jsonb non vérifiables avant l’application',
    diffSecret: 'champs scellés, non comparables',
    diffMore: '{n} de plus…',
    diffNeeded: 'Le démarrage s’arme quand l’aperçu reflète la sélection.',
    phase: 'État',
    phaseRunning: 'en cours',
    phaseComplete: 'complet',
    phaseError: 'erreur',
    secrets: 'Secrets',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholders',
    size: 'Taille',
    created: 'Créé',
    destination: 'Destination',
    download: 'Télécharger .tvbk',
    deleteCheckpoint: 'Supprimer le checkpoint',
    noCheckpoints: 'Aucun checkpoint — créez-en un depuis une destination.',
    families: 'Familles',
    generation: 'Génération',
    completedAt: 'Terminé le',
    errorDetail: "Détail de l'erreur",
    manifest: 'Manifest',
    restoreHint:
      "Chargez un artefact .tvbk : l'explorer montre ce qu'il contient, puis vous choisissez quoi restaurer et comment.",
    uploadFile: 'Charger un fichier .tvbk',
    uploading: 'Chargement…',
    uploadFailed: "Impossible d'ouvrir l'artefact",
    explorerTitle: 'Contenu du checkpoint',
    checkpointFrom: 'Checkpoint du cluster {cluster}, créé le {when} ({origin}, génération {generation})',
    otherCluster:
      "Ce checkpoint provient d'un AUTRE cluster ({cluster}) — la restauration cross-cluster arrive dans un round futur.",
    encrypted: 'chiffré',
    objectsCount: '{n} objets',
    mode: 'Mode',
    modeMerge: 'Merge — réconcilie : upsert des éléments sélectionnés, ne supprime rien',
    modeOverwrite:
      'Overwrite — le checkpoint gagne : une famille entièrement sélectionnée est remplacée en entier (les lignes actuelles absentes du checkpoint meurent)',
    restoreMasterpassHint:
      'La masterpass avec laquelle le checkpoint a été créé. Sans elle, les secrets chiffrés sont restaurés comme placeholders explicites.',
    checkMasterpass: 'Vérifier',
    masterpassOk: 'Masterpass correcte',
    masterpassWrong: 'Masterpass erronée',
    parachuteDestination: 'Destination parachute',
    parachuteHint: 'Avant de toucher la moindre ligne, la task crée ici un checkpoint automatique pré-restauration.',
    summaryTitle: 'Ce qui va se passer',
    summaryLine: '{family} : {what} — {mode}',
    summaryWhole: 'famille entière',
    summaryObjects: '{n} objets sélectionnés',
    confirmHint:
      'Saisissez le nom du cluster ({name}) pour confirmer — une restauration réécrit la configuration déclarée.',
    confirmField: 'Nom du cluster',
    startRestore: 'Restaurer',
    restoreRunning: 'Restauration en cours…',
    restoreDone: 'Restauration terminée — les reconcilers convergent vers la nouvelle déclaration.',
    restoreFailed: 'La restauration a échoué',
    discard: 'Abandonner',
    selectionEmpty: 'Sélectionnez au moins une famille ou un objet.'
  },

  backup: {
    intro: {
      title: 'Backup des données des VM et des containers',
      subtitle: 'Les briques que les logiciels de backup externes utilisent',
      whatItIs:
        'TVirt expose quatre primitives : snapshots quiesced, change tracking par disque, export NBD en lecture seule et export de la configuration. Veeam, Bacula, Acronis et consorts les pilotent.',
      whatItIsNot:
        "TVirt n'est pas un produit de backup : il ne planifie rien, n'applique aucune rétention et ne conserve aucune archive de vos données. Rétention, catalogues et politiques de restauration restent au logiciel que vous utilisez déjà."
    },
    cbt: {
      title: 'Suivi des modifications',
      colVm: 'VM',
      colDisk: 'Disque',
      colState: 'État',
      colBitmaps: 'Bitmaps',
      colObservedAt: 'Observé',
      colChangeId: 'Change ID',
      colMechanic: 'Mécanique',
      stateActive: 'Actif',
      stateInactive: 'Inactif',
      stateInconsistent: 'Incohérent — la prochaine sauvegarde doit être complète',
      stateBroken: 'Chaîne rompue — désactiver, puis réactiver comme nouvelle chaîne',
      stateSnapshots: 'Toujours actif — delta entre deux snapshots',
      stateUnavailable: 'Indisponible sur ce disque',
      mechanic: {
        'qcow2-bitmap': 'Bitmap qcow2',
        'rbd-snapdiff': 'Diff de snapshots Ceph',
        'lvm-thin-delta': 'Delta du thin pool',
        none: 'Aucune'
      },
      empty:
        'Aucun disque de VM. Le suivi se lit par disque : activez-le sur un disque qcow2, ou prenez des snapshots sur rbd/SAN.',
      chainBroken: 'Chaîne rompue',
      chainBrokenText:
        'Rompue par un {reason} : {bitmaps}. Désactivez la bitmap (la chaîne est perdue, la prochaine sauvegarde est complète), puis réactivez-la comme nouvelle chaîne.',
      lineages: 'Époques',
      epochFrozen: 'gelée dans le snapshot {snapshot}',
      epochLost: 'perdue ({cause})',
      epochRecording: "en cours d'enregistrement sur la tête",
      milestones: 'Jalons (snapshots)',
      enable: 'Activer le suivi',
      disable: 'Désactiver',
      reset: 'Réinitialiser',
      changedAreas: 'Zones modifiées',
      denied: "Vous n'avez pas la permission sur cette VM",
      enableTitle: 'Activer le suivi des modifications',
      disableTitle: 'Désactiver le suivi des modifications',
      resetTitle: 'Réinitialiser la bitmap',
      areasTitle: 'Zones modifiées',
      bitmapName: 'Nom de la bitmap',
      bitmapNameHint: 'Un nom à vous : tvirt- et tvbk- appartiennent à la plateforme',
      granularity: 'Granularité (octets)',
      granularityHint: 'Une puissance de deux ; 65536 par défaut',
      bitmap: 'Bitmap',
      disableHint: "Supprime la bitmap et tout son historique d'époques : la prochaine sauvegarde doit être complète.",
      resetHint: "Vide la bitmap — une nouvelle base : un change ID antérieur n'est plus composable.",
      areasFrom: 'Du snapshot',
      areasTo: 'Au snapshot',
      areasRun: 'Calculer',
      areasResult: '{count} zones modifiées, {bytes}',
      areasEmpty: 'Aucune zone modifiée entre les deux snapshots',
      areasZero: 'zéros',
      areasMore: 'les {shown} premières sur {count}',
      submit: 'Confirmer',
      error: "L'action de suivi a échoué"
    },
    exports: {
      title: 'Exports NBD ouverts',
      colVm: 'VM',
      colDisk: 'Disque',
      colSnapshot: 'Snapshot',
      colBitmap: 'Bitmap',
      colPhase: 'Phase',
      colNode: 'Nœud',
      colEndpoint: 'Endpoint',
      colExpires: 'Expire',
      colCreated: 'Ouvert',
      colError: 'Erreur',
      phase: {
        preparing: 'En préparation',
        ready: 'Prêt',
        closed: 'Fermé',
        error: 'Échoué'
      },
      expiresIn: 'dans {minutes} min',
      expired: 'expiré',
      empty: 'Aucun export. Une session en lecture sert un disque à un snapshot à un client NBD ; une session en écriture remplit un disque vierge d\'une VM arrêtée. Les deux meurent à l\'expiration.',
      endpointHint: "TLS avec la CA du cluster ; le nom de l'export est le ticket — il meurt avec la session",
      closeDenied: "Vous n'avez pas la permission de fermer les exports de cette VM",
      open: 'Ouvrir un export NBD',
      openTitle: 'Ouvrir un export NBD',
      openDisk: 'Disque',
      openBitmap: 'Bitmap (facultative)',
      openBitmapHint:
        "Publie l'époque de cette bitmap gelée dans ce snapshot comme meta-context des extents modifiés (disques qcow2 uniquement)",
      openTtl: 'Durée (minutes)',
      openSubmit: 'Ouvrir',
      openError: "L'export n'a pas pu être ouvert",
      colMode: 'Mode',
      mode: {
        read: 'Lecture',
        write: 'Écriture'
      },
      caCertificate: 'CA du cluster',
      caCopy: 'Copier le PEM',
      caDownload: 'Télécharger ca-cert.pem',
      caHint: 'Écrivez le PEM dans ca-cert.pem dans un dossier privé et connectez-vous avec nbds://…?tls-certificates=<dossier> (nbdcopy, nbdinfo) ou --object tls-creds-x509,dir=<dossier>,endpoint=client (qemu-img)',
      caAbsent: 'La session ne porte pas la CA (pas de PKI)',
      openWrite: 'Ouvrir un export en écriture',
      openWriteTitle: 'Ouvrir un export en écriture',
      openWriteIntro: 'Le disque doit être vierge : né vide, jamais écrit, sans snapshot ; la VM arrêtée. La restauration REMPLIT le disque, elle ne le répare pas. Tant que la session est ouverte, la VM ne démarre pas, ne prend pas de snapshot, ne se clone pas et le disque ne se déplace pas.',
      openWriteSubmit: 'Ouvrir',
      openWriteError: 'L\'export en écriture n\'a pas pu être ouvert',
      openWriteDenied: 'Vous n\'avez pas la permission vm.restore.data sur cette VM',
      openWriteStopped: 'Arrêtez la VM pour ouvrir un export en écriture',
      fromDescription: 'Créer une VM depuis une description',
      fromDescriptionTitle: 'Créer une VM depuis une description',
      fromDescriptionIntro: 'La description d\'export-vm-meta revient comme VM arrêtée avec les disques vides de la géométrie décrite — prête pour les exports en écriture, disque par disque. Les octets ne passent pas par ici : restore-disk (CLI) ou le client NBD du produit de sauvegarde les porte.',
      fromDescriptionDoc: 'Description (JSON)',
      fromDescriptionDocHint: 'Collez le document d\'export-vm-meta, ou choisissez le fichier',
      fromDescriptionFile: 'Choisir un fichier…',
      fromDescriptionInvalid: 'Le texte n\'est pas un document JSON',
      fromDescriptionName: 'Nom de la nouvelle VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Votre scope de départ',
      fromDescriptionStorage: 'Storage des disques',
      fromDescriptionStorageHint: 'Chaque disque naît ici, au format par défaut du storage',
      fromDescriptionMetadataStorage: 'Storage des métadonnées',
      fromDescriptionSameAsStorage: 'Le même que les disques',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Sans bridge ni réseau, la VM naît sans cartes',
      fromDescriptionNetwork: 'Réseau logique (fabric/réseau)',
      fromDescriptionSubmit: 'Créer',
      fromDescriptionError: 'La VM n\'a pas pu être créée',
      fromDescriptionDone: 'VM créée : {name}',
      fromDescriptionOpen: 'Ouvrir la VM',
      fromDescriptionDenied: 'Vous n\'avez pas la permission vm.create',
      fromDescriptionStillRunning: 'La création est encore en cours : on continue d\'attendre'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Sauvegardes de données des VM',
      titleOnVm: 'Sauvegardes de données',
      empty:
        "Aucune sauvegarde. Une sauvegarde copie les disques, le varstore UEFI et l'état du vTPM vers une destination, et survit à la VM.",
      colVm: 'VM',
      colCreated: 'Effectuée le',
      colPhase: 'Résultat',
      colDestination: 'Destination',
      colContains: 'Contenu',
      colSize: 'Taille',
      colOrigin: 'Origine',
      colMode: 'Type',
      retentionChip: 'Rétention',
      retentionHint:
        "La rétention de la destination peut supprimer cette sauvegarde sans rien demander : elle est née d'une planification. Les sauvegardes manuelles ne sont jamais balayées.",
      policyRemoved: 'Policy supprimée : {name}',
      policyRemovedHint:
        'La policy qui a planifié ce backup n’existe plus : aucune rétention ne le gouverne (jamais élagué automatiquement) — supprimez-le à la main quand il ne sert plus.',
      phase: {
        running: 'En cours',
        complete: 'Terminée',
        error: 'Échouée'
      },
      origin: {
        manual: 'Manuelle',
        schedule: 'Planifiée'
      },
      mode: {
        full: 'Complète',
        incremental: 'Incrémentale'
      },
      contains: {
        disks: 'Disques',
        varstore: 'Varstore UEFI',
        vtpm: 'État vTPM',
        snapshots: 'Instantanés'
      },
      vmState: {
        stopped: 'VM arrêtée',
        running: 'VM en marche (à chaud)'
      },
      artifactClass: { metadata: 'Métadonnées', data: 'Données', secret: 'Secret' },
      detail: {
        tabOverview: 'Synthèse',
        tabArtefact: 'Artefact',
        id: 'Identifiant',
        scope: 'Périmètre',
        vmState: 'État de la VM à la copie',
        pointInTime: 'Instant des données',
        completedAt: 'Achevée le',
        node: 'Nœud qui a copié',
        error: 'Erreur',
        path: 'Dossier sur le stockage',
        checksum: 'sha256 du manifest',
        secretsExposed: 'Matériel sensible en clair',
        secretsExposedYes: 'Oui — la destination ne chiffre pas',
        secretsExposedNo: 'Non',
        baseBackup: 'Sauvegarde de base',
        tabManifest: 'Manifest',
        manifestHint:
          "L'index en clair de l'artefact : un fichier par ligne avec son sha256. Le dossier se vérifie même sans TVirt — qemu-img, tar et jq suffisent.",
        manifestEmpty: 'Le manifest ne liste aucun fichier.',
        manifestError: 'Le manifest est illisible',
        colEntry: 'Fichier',
        colClass: 'Classe',
        colSha: 'sha256'
      },
      create: {
        action: 'Sauvegarder maintenant',
        title: 'Sauvegarder maintenant',
        submit: 'Lancer la sauvegarde',
        destination: 'Destination',
        destinationHint: 'Seules les destinations qui acceptent les sauvegardes.',
        noDestinations: "Aucune destination n'accepte les sauvegardes : créez-en une dans Système → Checkpoints.",
        contentsHint:
          "Tous les disques voyagent, plus le varstore UEFI et l'état du vTPM. Ces deux-là sont l'essentiel : un guest scellé doit redémarrer.",
        error: "La sauvegarde n'a pas démarré",
        stillRunning: 'Sauvegarde toujours en cours — la copie continue même si vous fermez.',
        vmRunning:
          'La VM est {phase} : la sauvegarde exige une VM stable — arrêtée pour la copie à froid, en marche pour la copie à chaud.'
      },
      restore: {
        action: 'Restaurer',
        title: 'Restaurer',
        intro:
          "La restauration est irréversible. Choisissez où les données reviennent : dans une machine neuve, ou par-dessus celle d'origine.",
        modeNewVm: 'Restaurer dans une NOUVELLE VM',
        modeNewVmHint:
          "Ne touche à rien de ce qui existe — c'est l'option avec laquelle on vérifie une sauvegarde. Identifiant neuf et MAC fraîchement frappées.",
        modeOver: "Écraser la VM d'origine",
        modeOverHint: 'Détruit les données actuelles de la VM cible, sans retour possible. La VM doit être arrêtée.',
        newName: 'Nom de la nouvelle VM',
        newNameHint: 'Il doit être libre dans le périmètre de destination.',
        storage: 'Stockage des disques',
        storageHint:
          "Obligatoire : le manifest enregistre la taille et le format d'un disque, jamais le stockage d'où il venait.",
        metadataStorage: 'Stockage du varstore et du vTPM',
        metadataStorageHint: "Où atterrissent l'identité UEFI et l'état du vTPM.",
        sameAsStorage: 'Le même que les disques',
        bridge: "Bridge de l'hôte",
        bridgeHint:
          'Chaque carte enregistrée revient sur ce bridge avec une MAC neuve. Laissé vide, la VM naît sans cartes — le défaut le plus sûr.',
        overwriteTitle: "Vous êtes sur le point d'écraser cette VM",
        overwriteName: 'Nom',
        overwriteId: 'Identifiant',
        overwriteDisks: 'Disques qui seront réécrits',
        overwriteNoDisks: 'Aucun disque.',
        overwriteKeeps:
          "Restent intacts l'identifiant, le nom, le périmètre, les cartes réseau et les MAC : une sauvegarde, ce sont les DONNÉES, la configuration est le checkpoint.",
        confirmField: 'Nom de la VM',
        confirmHint: 'Saisissez {name} pour confirmer.',
        targetLoading: 'Lecture de la VM cible…',
        targetRunning:
          'La VM cible est {phase} : la restauration réécrit les octets sous le guest, elle la veut donc arrêtée.',
        targetGone: "La VM d'origine n'est plus lisible : il reste la restauration dans une VM neuve.",
        onlyComplete: 'La sauvegarde est {phase} : seule une sauvegarde terminée peut restaurer.',
        submitNewVm: 'Restaurer dans la nouvelle VM',
        submitOver: 'Écraser',
        error: "La restauration n'a pas démarré",
        stillRunning: 'Restauration toujours en cours — copier des disques entiers prend du temps.'
      }
    },
    guest: {
      title: {
        ct: 'Sauvegardes de données des conteneurs',
        app: 'Sauvegardes de données des App'
      },
      tabTitle: 'Sauvegardes',
      empty:
        'Aucune sauvegarde. Une sauvegarde copie les données persistantes vers une destination et survit à son objet.',
      colSubject: {
        ct: 'Conteneur',
        app: 'App'
      },
      colCreated: 'Prise le',
      colPhase: 'Issue',
      colDestination: 'Destination',
      colContains: 'Contenu',
      colSize: 'Taille',
      colOrigin: 'Origine',
      policyRemoved: 'Policy supprimée : {name}',
      policyRemovedHint:
        'La policy qui a planifié ce backup n’existe plus : aucune rétention ne le gouverne (jamais élagué automatiquement) — supprimez-le à la main quand il ne sert plus.',
      phase: {
        running: 'En cours',
        complete: 'Terminée',
        error: 'Échouée'
      },
      origin: {
        manual: 'Manuelle',
        schedule: 'Planifiée'
      },
      state: {
        stopped: 'Objet arrêté',
        running: 'Objet en marche (gelé)'
      },
      contains: {
        rootfs: 'Arbre rootfs',
        config: 'Configuration',
        volumes: 'Volumes persistants',
        root: 'Root persistante'
      },
      artifactClass: {
        metadata: 'Métadonnées',
        data: 'Données',
        secret: 'Secret'
      },
      create: {
        action: 'Sauvegarder maintenant',
        title: 'Nouvelle sauvegarde',
        submit: 'Lancer la sauvegarde',
        error: "La sauvegarde n'a pas démarré",
        destination: 'Destination',
        destinationHint: 'Seules les destinations qui acceptent les sauvegardes de données.',
        noDestinations:
          "Aucune destination n'accepte les sauvegardes de données : ajoutez « Sauvegardes de données » à une destination.",
        hint: {
          ct: "L'arbre rootfs entier voyage, fidèlement (propriétaires numériques, xattrs, ACL), plus la configuration déclarée dans le manifeste. Un conteneur en marche est GELÉ pendant tout l'empaquetage : copie crash-consistent, déclarée.",
          app: 'SEULS les volumes persistants (et la root persistante) voyagent, plus la configuration dans le manifeste. Les éléments éphémères sont exclus par ratification et le manifeste les nomme ; les valeurs env déclarées secrètes ne voyagent pas.'
        },
        stillRunning: 'Sauvegarde encore en cours — empaqueter des arbres entiers prend du temps.'
      },
      detail: {
        tabOverview: "Vue d'ensemble",
        tabManifest: 'Manifeste',
        id: 'Identifiant',
        scope: 'Portée',
        state: 'État à la copie',
        pointInTime: "Données à l'instant",
        completedAt: 'Conclue le',
        node: 'Nœud qui a copié',
        error: 'Erreur',
        path: 'Répertoire sur le stockage',
        checksum: 'sha256 du manifeste',
        manifestHint:
          "L'index de l'artefact : une entrée par fichier avec son sha256 — sans les hachages, « la sauvegarde est là » est un acte de foi.",
        manifestError: 'Le manifeste ne peut pas être lu',
        manifestEmpty: 'Aucun artefact dans le manifeste.',
        colEntry: 'Fichier',
        colClass: 'Classe',
        colSha: 'sha256',
        excluded: 'Exclu par ratification (ne voyage pas)',
        secretKeys: 'Clés env secrètes omises (#307) — à ressaisir après une restauration'
      },
      restore: {
        action: 'Restaurer',
        title: 'Restauration',
        submit: 'Restaurer',
        error: "La restauration n'a pas démarré",
        stillRunning: 'Restauration encore en cours — extraire des arbres entiers prend du temps.',
        onlyComplete: 'La sauvegarde est {phase} : seule une sauvegarde terminée peut restaurer.',
        asNew: {
          ct: 'Dans un NOUVEAU conteneur — ne détruit rien : le geste avec lequel on vérifie une sauvegarde',
          app: 'Dans une NOUVELLE App — ne détruit rien : le geste avec lequel on vérifie une sauvegarde'
        },
        over: {
          ct: "SUR le conteneur d'origine — l'arbre rootfs entier est remplacé",
          app: "SUR l'App d'origine — le contenu de chaque volume persistant est remplacé"
        },
        name: 'Nom du nouvel objet',
        storage: 'Stockage',
        storageHint: "Où atterrissent les données restaurées — le manifeste n'enregistre jamais le pool perdu.",
        storageDeclared: 'Les stockages déclarés dans le manifeste',
        bridge: "Bridge de l'hôte",
        bridgeHint:
          'Chaque carte enregistrée revient sur ce bridge avec une MAC neuve. Vide = naît détaché, le défaut le plus sûr.',
        node: 'Nœud',
        nodeHint:
          "Le membre sur lequel l'App renaît : le nœud est une identité de cluster et ne vient jamais du manifeste.",
        secretKeysWarning:
          "Les valeurs env déclarées secrètes ne voyagent pas dans la sauvegarde : la copie rennée veut qu'on les ressaisisse (le journal du task nomme les clés).",
        overInventory: "Vous êtes sur le point d'écraser cet objet",
        confirmType: 'Tapez {name} pour confirmer',
        targetGone: "L'objet d'origine ne peut plus être lu : la restauration comme nouveau reste disponible.",
        targetLoading: "Lecture de l'objet cible…",
        targetRunning:
          "L'objet cible est en marche : la restauration remplace les octets sous l'invité et le veut donc arrêté."
      }
    }
  }
}
